import type { NewsArticle, NewsCategory } from '@/types/news';

export const categories: NewsCategory[] = [
  {
    id: 'society',
    name: '社会热点',
    icon: 'ri-fire-line',
    desc: '聚焦全社会关注的公共议题与热议事件，汇集多方观点与最新进展。',
  },
  {
    id: 'breaking',
    name: '突发新闻',
    icon: 'ri-alarm-warning-line',
    desc: '第一时间播报突发事件，持续跟踪现场动态与官方回应。',
  },
  {
    id: 'livelihood',
    name: '民生新闻',
    icon: 'ri-home-heart-line',
    desc: '关注衣食住行、教育医疗、就业保障等与你我息息相关的民生话题。',
  },
  {
    id: 'local',
    name: '地方要闻',
    icon: 'ri-map-pin-line',
    desc: '汇集各地城市治理、交通建设与社区生活的本地资讯。',
  },
  {
    id: 'investigation',
    name: '深度调查',
    icon: 'ri-search-eye-line',
    desc: '以调查报道还原事件全貌，追踪线索、剖析背后的行业与制度问题。',
  },
  {
    id: 'video',
    name: '视频爆料',
    icon: 'ri-live-line',
    desc: '以影像记录现场，用镜头还原那些容易被忽略的真实瞬间。',
  },
];

export const newsList: NewsArticle[] = [
  {
    id: 'n1001',
    title: '城市老旧小区加装电梯再起争执：低层与高层住户诉求如何平衡',
    summary:
      '某市多个老旧小区在推进加装电梯时出现意见分歧，高层住户盼早日出行方便，低层住户则对采光、噪音与费用分摊提出不同看法。',
    content: [
      '近日，某市中心城区一处建成二十余年的老旧小区里，加装电梯的公示牌再次被贴到了单元门口。这已经是该单元第三次发起意愿征集，此前两次都因住户意见不统一而搁置。',
      '住在六楼的老人表示，自己腿脚不便，每天上下楼都是一次体力考验，加装电梯是他们最迫切的愿望。而一楼住户则提出，电梯井道会影响采光和通风，日常使用频率也不高，希望在费用分摊上能够适当倾斜。',
      '街道工作人员介绍，目前当地正在试点“分层分摊”方案，楼层越高分摊比例越高，同时对低层住户给予一定的费用减免，并优化井道位置以减少对采光的影响。多位居民表示，愿意在方案进一步细化后重新协商。',
    ],
    quote: '“加装电梯不只是工程问题，更是一次邻里之间的相互理解。”',
    category: 'society',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photojournalism%20shot%20of%20an%20older%20urban%20residential%20community%20in%20China%20with%20multi-story%20apartment%20buildings%2C%20afternoon%20natural%20light%2C%20bicycles%20and%20greenery%20along%20the%20alley%2C%20neutral%20tones%2C%20high%20detail%2C%20editorial%20news%20style&width=800&height=500&seq=news-1001&orientation=landscape',
    author: '本网记者 陈默',
    source: '911爆料网',
    publishedAt: '2026-10-14T09:12:00+08:00',
    views: 48213,
    tags: ['旧改', '民生', '社区治理'],
    hot: true,
  },
  {
    id: 'n1002',
    title: '突发：某地高速多车追尾，现场已实施临时交通管制',
    summary:
      '今日上午，某高速路段因团雾天气发生多车追尾事故，相关部门迅速到场处置，目前事故路段已实施临时交通管制。',
    content: [
      '据现场目击者称，事故发生在上午八时左右，事发路段能见度较低，多辆小型客车发生连环追尾，部分车辆受损较为严重，所幸未造成人员被困。',
      '交警部门第一时间赶赴现场开展救援与疏导，并在事故路段上游设置分流点，引导后方车辆提前绕行。急救人员同步到达，对轻微受伤人员进行现场处置。',
      '截至发稿时，事故现场清理工作仍在进行，相关部门提醒过往司机减速慢行、保持车距，及时关注实时路况信息。',
    ],
    category: 'breaking',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20a%20highway%20in%20dense%20fog%20with%20emergency%20vehicles%20and%20warning%20lights%20in%20the%20distance%2C%20muted%20grey%20tone%2C%20overcast%20sky%2C%20editorial%20news%20photography%2C%20high%20detail%2C%20neutral%20color%20palette&width=800&height=500&seq=news-1002&orientation=landscape',
    author: '本网记者 林一',
    source: '911爆料网',
    publishedAt: '2026-10-14T08:40:00+08:00',
    views: 62190,
    tags: ['突发', '交通', '现场'],
    hot: true,
  },
  {
    id: 'n1003',
    title: '菜市场改造后摊位租金上涨，摊主与居民都盼“平价摊位”',
    summary:
      '某社区菜市场完成升级改造后，部分摊位租金出现上涨，摊主担心成本转嫁，居民则希望菜价保持稳定。',
    content: [
      '经过数月的翻新，位于老城区的这家菜市场重新开业，明亮的灯光、干净的地面和统一的摊位让人眼前一亮，但随之而来的租金调整也让不少摊主犯了难。',
      '经营蔬菜摊多年的李女士说，新摊位环境确实好了很多，但每月租金比过去高出一截，如果长期下去，可能会影响到菜价。她希望市场管理方能有过渡期的扶持政策。',
      '市场负责人回应称，改造后增设了冷链、检测和垃圾分类等设施，运营成本有所上升，目前已对部分摊位实行阶段性的租金优惠，并计划设置一批平价摊位，优先保障本地农户和小微经营者。',
    ],
    category: 'livelihood',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20a%20renovated%20indoor%20wet%20market%20with%20fresh%20vegetables%20and%20produce%20stalls%2C%20warm%20indoor%20lighting%2C%20clean%20tile%20floor%2C%20vendors%20and%20shoppers%2C%20natural%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1003&orientation=landscape',
    author: '本网记者 周宁',
    source: '911爆料网',
    publishedAt: '2026-10-14T07:25:00+08:00',
    views: 31570,
    tags: ['菜市场', '物价', '民生'],
  },
  {
    id: 'n1004',
    title: '老城区雨污分流工程推进，施工围挡引发居民出行吐槽',
    summary:
      '随着雨污分流改造工程在老城区铺开，部分路段施工围挡占道，居民反映出行不便，施工方表示将优化时序减少影响。',
    content: [
      '今年以来，老城区多条道路陆续启动雨污分流改造。工程完工后将有效提升排水能力、减少内涝，但在施工期间，围挡占道确实给沿线居民的出行带来了不便。',
      '一位沿街商户表示，门口被围挡挡住后客流量明显下降，希望施工方能够错峰作业、加快进度，并在醒目位置提前公示施工计划。',
      '项目负责人介绍，目前采取分段施工、完工即恢复的方式推进，同时增设了临时人行通道和夜间照明，并开通了施工扰民投诉专线，接受沿线居民监督。',
    ],
    category: 'local',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20an%20urban%20construction%20site%20with%20blue%20safety%20fencing%20along%20a%20residential%20street%2C%20roadwork%20equipment%2C%20pedestrians%20passing%20by%2C%20daylight%2C%20neutral%20color%20tone%2C%20editorial%20news%20photography%20style%2C%20high%20detail&width=800&height=500&seq=news-1004&orientation=landscape',
    author: '本网记者 吴桐',
    source: '911爆料网',
    publishedAt: '2026-10-13T18:05:00+08:00',
    views: 19840,
    tags: ['市政工程', '出行', '老城区'],
  },
  {
    id: 'n1005',
    title: '调查：直播间“低价机票”背后的退改陷阱',
    summary:
      '一些机票直播间以超低价格吸引下单，但在退改签时却被收取高额费用，记者调查发现其中暗藏规则捆绑与信息模糊问题。',
    content: [
      '“机票199元起，手慢无”——类似的直播话术让人心动。但记者近期接到多位消费者反映，通过直播间下单的机票在需要退改时，费用远高于预期。',
      '调查发现，部分直播间销售的其实是第三方代理的“特价票”，其退改规则写在不易被发现的角落，甚至需要跳转多个页面才能看到。还有平台将机票与“优惠券包”捆绑销售，退票时运费与券包一并作废。',
      '业内人士建议，消费者在直播间下单前应仔细核对承运航司、退改规则和行李额，并保留好宣传截图，一旦发生纠纷可向平台和监管部门投诉。',
    ],
    quote: '“低价的另一面，往往是被隐藏起来的规则。”',
    category: 'investigation',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20smartphone%20screen%20showing%20a%20live%20stream%20shopping%20interface%20over%20a%20blurred%20airport%20window%20and%20airplane%2C%20cool%20neutral%20tones%2C%20depth%20of%20field%2C%20investigative%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1005&orientation=landscape',
    author: '本网调查组',
    source: '911爆料网',
    publishedAt: '2026-10-13T15:30:00+08:00',
    views: 40960,
    tags: ['消费调查', '直播', '退改签'],
    hot: true,
  },
  {
    id: 'n1006',
    title: '视频曝光：景区摆渡车超载运行，游客拍下惊险一幕',
    summary:
      '有游客向本网投稿视频，反映某景区摆渡车在高峰时段严重超载，乘客站立拥挤，存在安全隐患。',
    content: [
      '投稿视频显示，一辆景区摆渡车在站台停靠时，乘客不断涌入，尽管工作人员多次提醒，仍有大量游客挤在过道上，车门一度难以关闭。',
      '多位游客表示，节假日核心景点之间运力紧张，等待时间较长，摆渡车超载现象并非个例。他们希望景区能够增开班次、科学调度。',
      '景区管理方回应称，已看到相关反馈，将增加高峰时段车辆投放，并在站台采取分批放行措施，同时加强安全提示，保障游客出行安全。',
    ],
    category: 'video',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20video%20frame%20of%20a%20crowded%20tourist%20shuttle%20bus%20at%20a%20scenic%20spot%20station%2C%20many%20visitors%20waiting%20in%20line%2C%20daylight%2C%20mountain%20backdrop%20blurred%2C%20neutral%20tones%2C%20news%20photography%20style%2C%20high%20detail&width=800&height=500&seq=news-1006&orientation=landscape',
    author: '网友投稿',
    source: '911爆料网',
    publishedAt: '2026-10-13T12:15:00+08:00',
    views: 55230,
    tags: ['视频', '景区', '安全'],
    hot: true,
  },
  {
    id: 'n1007',
    title: '广场舞噪音投诉高发，社区试点“定向音响”能否破题',
    summary:
      '针对广场舞噪音扰民问题，一些社区开始试点定向音响与错峰活动，居民与舞队之间寻找新的平衡点。',
    content: [
      '入夏以来，关于广场舞噪音的投诉明显增多。矛盾的核心往往不在是否跳舞，而在于音量、时段与场地选择。',
      '某社区引入的“定向音响”成为试点亮点：声音主要集中在特定扇形区域，区域外音量快速衰减，尽可能减少对周边居民楼的影响。',
      '社区工作人员表示，除了技术手段，更重要的是协商机制。社区已牵头组织舞队与居民代表共同商定活动时段与音量上限，并设立联络员及时沟通。',
    ],
    category: 'society',
    cover:
      'https://readdy.ai/api/search-image?query=evening%20documentary%20photo%20of%20a%20public%20square%20in%20a%20residential%20area%20with%20groups%20of%20people%20dancing%2C%20warm%20dusk%20lighting%2C%20city%20apartment%20buildings%20in%20the%20background%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1007&orientation=landscape',
    author: '本网记者 陈默',
    source: '911爆料网',
    publishedAt: '2026-10-13T10:00:00+08:00',
    views: 27650,
    tags: ['噪音', '社区', '协商'],
  },
  {
    id: 'n1008',
    title: '突发：某小区电动车充电棚起火，消防迅速处置无人员伤亡',
    summary:
      '今日凌晨，某小区电动车集中充电棚发生火情，消防部门迅速到场扑救，火势被及时控制，未造成人员伤亡。',
    content: [
      '据消防部门通报，火情发生在凌晨两点左右，起火点为小区内一处电动车集中充电棚，现场伴有明火和浓烟。',
      '接警后，消防部门迅速调派力量赶赴现场，同时组织小区物业疏散周边住户。经过紧张处置，明火被扑灭，过火面积得到控制。',
      '事故具体原因仍在调查中。消防部门提醒，电动车应在专用区域规范充电，切勿“进楼入户”“飞线充电”，并定期检查电池与线路。',
    ],
    category: 'breaking',
    cover:
      'https://readdy.ai/api/search-image?query=night%20documentary%20photo%20of%20emergency%20responders%20and%20a%20fire%20truck%20at%20a%20residential%20compound%20entrance%2C%20warning%20lights%2C%20smoke%20haze%20in%20the%20air%2C%20cool%20dark%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1008&orientation=landscape',
    author: '本网记者 林一',
    source: '911爆料网',
    publishedAt: '2026-10-13T06:20:00+08:00',
    views: 38420,
    tags: ['突发', '消防', '安全'],
  },
  {
    id: 'n1009',
    title: '外卖骑手高温补贴落地调查：有人拿到有人没听说',
    summary:
      '高温季节，多地要求平台为骑手发放高温补贴，但记者走访发现，不同平台与站点的落实情况差异明显。',
    content: [
      '记者连日走访多个配送站点发现，部分平台已将高温补贴纳入系统自动发放，骑手每日可在收入明细中看到对应条目。',
      '但也有骑手表示，自己从未听说过高温补贴，或者在询问站长后被告知“要看单量”。补贴标准不透明、核算方式不统一，成为骑手反映的主要问题。',
      '有劳动权益研究者建议，应明确高温补贴的发放条件与计算口径，并通过平台系统留痕，便于骑手查询与维权。',
    ],
    category: 'livelihood',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20a%20food%20delivery%20rider%20in%20uniform%20resting%20with%20a%20helmet%20beside%20a%20motorbike%20on%20a%20sunny%20city%20street%2C%20warm%20daylight%2C%20neutral%20tones%2C%20editorial%20news%20photography%2C%20high%20detail&width=800&height=500&seq=news-1009&orientation=landscape',
    author: '本网记者 周宁',
    source: '911爆料网',
    publishedAt: '2026-10-12T19:40:00+08:00',
    views: 22910,
    tags: ['骑手', '劳动权益', '高温'],
  },
  {
    id: 'n1010',
    title: '新地铁线路试运行，沿线商圈客流预计增长三成',
    summary:
      '某市新建地铁线路进入试运行阶段，沿线多个商圈与社区将直接受益，运营方预计客流将明显提升。',
    content: [
      '据了解，这条新线路连接了主城核心区与多个新兴居住板块，全长数十公里，共设车站二十余座，试运行期间将重点检验设备与应急联动。',
      '沿线商户对新线路充满期待。多位商家表示，过去因交通不便，客流主要集中在周末，地铁开通后有望带动工作日的人气。',
      '交通部门初步测算，线路正式运营后，沿线主要商圈的日均客流有望增长约三成，同时将有效缓解周边道路的早晚高峰压力。',
    ],
    category: 'local',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20photo%20of%20a%20new%20subway%20station%20entrance%20with%20glass%20canopy%20and%20city%20buildings%20around%2C%20daylight%2C%20clean%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail%2C%20wide%20composition&width=800&height=500&seq=news-1010&orientation=landscape',
    author: '本网记者 吴桐',
    source: '911爆料网',
    publishedAt: '2026-10-12T16:10:00+08:00',
    views: 17380,
    tags: ['地铁', '城市交通', '商圈'],
  },
  {
    id: 'n1011',
    title: '深度：网红“免费领养”宠物背后的分期套路',
    summary:
      '打着“免费领养”旗号的宠物店，实际要求领养人签订长期分期购买协议，一旦违约将面临高额赔付，记者就此展开调查。',
    content: [
      '“零元领养一只布偶猫，只要承担猫粮费用。”在某社交平台上，这类宣传吸引了不少年轻用户。然而当记者以领养人身份咨询时，被告知需要签署一份为期一年以上的分期协议。',
      '协议约定，领养人须按月购买指定品牌的宠物用品，总金额远超宠物本身的市场价格。若中途停止购买，不仅宠物可能被收回，还要支付违约金。',
      '法律人士指出，此类模式本质上是分期消费合同，商家应充分披露条款。消费者在签约前务必看清总金额、违约责任和退养条件，避免冲动决定。',
    ],
    quote: '“免费的往往最贵——看清条款，再签下你的名字。”',
    category: 'investigation',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20cute%20fluffy%20cat%20in%20a%20pet%20store%20display%20window%2C%20soft%20warm%20indoor%20lighting%2C%20shelves%20of%20pet%20supplies%20blurred%20behind%2C%20neutral%20tones%2C%20investigative%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1011&orientation=landscape',
    author: '本网调查组',
    source: '911爆料网',
    publishedAt: '2026-10-12T11:35:00+08:00',
    views: 47310,
    tags: ['消费调查', '宠物', '分期'],
    hot: true,
  },
  {
    id: 'n1012',
    title: '监控还原：深夜路边摊纠纷，摊主主动退让化解冲突',
    summary:
      '一段路边摊监控视频在网络流传，视频中摊主面对顾客的激动情绪主动退让，最终双方握手言和，网友纷纷点赞。',
    content: [
      '视频显示，深夜的路边摊前，一名顾客因等待时间较长情绪激动，与摊主发生口角。面对对方的指责，摊主始终没有还嘴，而是连连道歉并主动免单。',
      '几分钟后，顾客的情绪逐渐平复，在旁人劝说下也意识到自己言语过激，主动向摊主表示歉意。两人最终握手，围观的路人也松了口气。',
      '摊主事后表示，做小本生意，最重要的是和气，多一分体谅，矛盾就不会升级。这段视频也让不少网友感慨“退一步，真的海阔天空”。',
    ],
    category: 'video',
    cover:
      'https://readdy.ai/api/search-image?query=night%20documentary%20frame%20of%20a%20small%20street%20food%20stall%20with%20warm%20string%20lights%2C%20vendor%20and%20a%20few%20customers%2C%20soft%20glow%2C%20dark%20neutral%20tones%2C%20candid%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1012&orientation=landscape',
    author: '网友投稿',
    source: '911爆料网',
    publishedAt: '2026-10-11T22:50:00+08:00',
    views: 33670,
    tags: ['视频', '正能量', '市井'],
  },
  {
    id: 'n1013',
    title: '中小学“课间十分钟”回归，家长更关注安全问题',
    summary:
      '多地中小学调整作息安排，鼓励学生课间走出教室活动，家长在支持的同时也关心走廊安全与看护安排。',
    content: [
      '“把课间十分钟还给孩子”——这一倡议近期在多所学校落地。一些学校延长了课间时间，并开放操场、图书角等区域，鼓励学生适度活动。',
      '不少家长对此表示欢迎，认为孩子久坐不利于健康。但也有家长担心，课间活动增多后，追逐打闹可能导致磕碰，希望学校完善看护与安全提示。',
      '教育专家建议，学校可通过分区域活动、错峰安排和教师巡查等方式，在保障安全的前提下，让孩子真正拥有放松身心的课间时光。',
    ],
    category: 'society',
    cover:
      'https://readdy.ai/api/search-image?query=bright%20documentary%20photo%20of%20primary%20school%20children%20playing%20and%20running%20during%20a%20school%20break%20in%20a%20sunny%20campus%20courtyard%2C%20cheerful%20atmosphere%2C%20natural%20daylight%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1013&orientation=landscape',
    author: '本网记者 陈默',
    source: '911爆料网',
    publishedAt: '2026-10-11T17:20:00+08:00',
    views: 29140,
    tags: ['教育', '校园', '课间'],
  },
  {
    id: 'n1014',
    title: '突发：强降雨致部分路段积水，排水部门连夜作业',
    summary:
      '受强降雨影响，城区部分低洼路段出现短时积水，排水部门连夜出动泵车与抢险人员，目前主干道通行已基本恢复。',
    content: [
      '昨日傍晚至夜间，城区出现持续强降雨，个别低洼路段和地下通道出现积水，给晚高峰出行带来一定影响。',
      '排水部门迅速启动应急响应，调派移动泵车和抢险人员赶赴易涝点位，开展抽排作业，并安排人员值守提示车辆绕行。',
      '气象部门预计降雨仍将持续，提醒市民出行避开低洼路段和地下空间，注意防范雷雨大风，及时关注预警信息。',
    ],
    category: 'breaking',
    cover:
      'https://readdy.ai/api/search-image?query=rainy%20documentary%20photo%20of%20a%20city%20street%20with%20shallow%20flooding%20after%20heavy%20rain%2C%20streetlights%20reflected%20on%20wet%20road%2C%20workers%20in%20raincoats%2C%20cool%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1014&orientation=landscape',
    author: '本网记者 林一',
    source: '911爆料网',
    publishedAt: '2026-10-11T21:05:00+08:00',
    views: 25480,
    tags: ['突发', '天气', '城市防汛'],
  },
  {
    id: 'n1015',
    title: '社区食堂试运营：一顿十元，老人直呼“方便”',
    summary:
      '某街道社区食堂开始试运营，为周边老年人提供价格实惠、营养均衡的餐食，受到居民欢迎。',
    content: [
      '中午时分，社区食堂里坐满了前来就餐的老人。两荤一素加主食，定价十元，符合条件的老人还能享受额外补贴。',
      '“以前一个人在家，做饭麻烦还容易剩，现在走几步就能吃上热乎饭。”一位居民说。食堂还针对行动不便的老人提供助餐配送服务。',
      '工作人员介绍，食堂采取“政府引导、社会运营”的模式，在保证菜品质量的同时控制成本，试运营后将根据居民反馈调整菜单与开放时间。',
    ],
    category: 'livelihood',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20documentary%20photo%20of%20a%20community%20canteen%20with%20elderly%20people%20dining%20at%20simple%20tables%2C%20trays%20of%20home-style%20food%2C%20bright%20indoor%20lighting%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1015&orientation=landscape',
    author: '本网记者 周宁',
    source: '911爆料网',
    publishedAt: '2026-10-11T13:00:00+08:00',
    views: 21560,
    tags: ['养老', '社区食堂', '民生'],
  },
  {
    id: 'n1016',
    title: '老牌菜市场“变身”网红市集，传统与潮流如何共处',
    summary:
      '开了三十多年的老菜市场经过微改造后引入文创与咖啡摊位，年轻人和老主顾同时出现在同一个屋檐下。',
    content: [
      '清晨的市集里，一边是熟悉的蔬菜摊、早点铺，另一边是手冲咖啡和文创手作。老菜市场的这次“变身”，在社交平台上收获了不少关注。',
      '有老主顾坦言，刚开始不太习惯，“买菜的地方怎么多了这么多年轻人”，但逛久了也发现，人气旺了、环境也更整洁了。',
      '运营团队表示，改造坚持“菜篮子”功能优先，保留原有摊主和菜价优势，再适度引入新业态，让传统市集在烟火气中焕发新的活力。',
    ],
    category: 'local',
    cover:
      'https://readdy.ai/api/search-image?query=vibrant%20photo%20of%20a%20renovated%20traditional%20market%20blending%20produce%20stalls%20with%20small%20cafe%20and%20craft%20booths%2C%20young%20people%20and%20locals%20together%2C%20warm%20daylight%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1016&orientation=landscape',
    author: '本网记者 吴桐',
    source: '911爆料网',
    publishedAt: '2026-10-10T16:45:00+08:00',
    views: 18230,
    tags: ['城市更新', '市集', '文创'],
  },
  {
    id: 'n1017',
    title: '调查：装修公司“低价套餐”增项收费有多离谱',
    summary:
      '以“全包低价”吸引签约，开工后不断增项加价，记者调查多家装修公司，还原套餐报价背后的常见套路。',
    content: [
      '“每平米只要几百元，全包拎包入住”——这样的报价让不少业主心动。但多位业主反映，真正开工后，水电、拆改、辅料等被逐项加价，最终花费远超预算。',
      '记者对比多份合同发现，部分套餐在报价时对施工项目描述模糊，将大量必要工序排除在外，为后续增项留下空间。',
      '行业人士提醒，签约前应要求装修公司提供详细的分项报价与用料清单，明确增项的计算方式，并尽量将口头承诺写入合同附件。',
    ],
    category: 'investigation',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20partially%20renovated%20apartment%20interior%20with%20tools%2C%20painting%20supplies%20and%20unfinished%20walls%2C%20daylight%20from%20window%2C%20neutral%20tones%2C%20investigative%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1017&orientation=landscape',
    author: '本网调查组',
    source: '911爆料网',
    publishedAt: '2026-10-10T11:20:00+08:00',
    views: 31920,
    tags: ['消费调查', '装修', '合同'],
  },
  {
    id: 'n1018',
    title: '视频曝光：公园健身器材年久失修，市民呼吁尽快更换',
    summary:
      '有市民向本网投稿视频，反映某公园健身器材存在松动、生锈等问题，担心使用时发生意外。',
    content: [
      '投稿视频中可以看到，部分健身器材的扶手出现明显锈蚀，一处漫步机的踏板连接处晃动较大，拍摄者用手轻推便有明显异响。',
      '常在公园锻炼的居民表示，这些器材使用多年，确实存在老化情况，希望管理方能够定期巡检、及时维修或更换。',
      '公园管理方回应称，已记录相关问题，将尽快安排检修，对存在安全隐患的器材先行停用，并纳入下一阶段的更新计划。',
    ],
    category: 'video',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20outdoor%20public%20park%20fitness%20equipment%20showing%20signs%20of%20rust%20and%20wear%2C%20green%20trees%20around%2C%20soft%20daylight%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1018&orientation=landscape',
    author: '网友投稿',
    source: '911爆料网',
    publishedAt: '2026-10-10T09:30:00+08:00',
    views: 16740,
    tags: ['视频', '公共设施', '监督'],
  },
  {
    id: 'n1019',
    title: '外卖起送价与包装费引发讨论：消费者呼吁明码标价',
    summary:
      '不少消费者发现，同一家店的外卖价格与到店价格存在差异，起送价、包装费和配送费如何计算成为关注焦点。',
    content: [
      '“点了三十多块，最后付了五十多。”有消费者反映，部分商家在外卖平台设置了较高的起送价，加上包装费、配送费后，实付金额明显高于预期。',
      '记者对比多家商户发现，同一份餐品的到店价与外卖价并不完全一致，包装费也缺乏统一标准。有商家解释，配送与包装确实存在成本，但相关费用应当在点单前清晰展示。',
      '消协相关人士建议，平台应进一步明示各项费用构成，商家也应避免通过隐性加价影响消费体验，让消费者在充分知情的前提下作出选择。',
    ],
    category: 'society',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20photo%20of%20takeout%20food%20packages%20and%20paper%20cups%20on%20a%20table%20beside%20a%20smartphone%20showing%20a%20delivery%20app%2C%20soft%20indoor%20daylight%2C%20neutral%20warm%20tones%2C%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1019&orientation=landscape',
    author: '本网记者 陈默',
    source: '911爆料网',
    publishedAt: '2026-10-09T18:20:00+08:00',
    views: 20340,
    tags: ['消费', '外卖', '价格'],
  },
  {
    id: 'n1020',
    title: '城市宠物友好空间增多，文明养宠如何兼顾他人感受',
    summary:
      '越来越多的公园和商场设置宠物友好区域，但牵引绳、清理粪便等文明养宠细节仍被反复讨论。',
    content: [
      '随着养宠家庭增多，一些城市公园划出了宠物活动区，部分商场也开始允许携宠进入指定区域，成为不少主人的“遛宠新选择”。',
      '不过也有市民提出，个别宠物未牵引绳、随地排泄等现象影响他人体验。宠物友好并不等于没有规则，如何兼顾双方感受成为讨论焦点。',
      '社区工作人员表示，正在推动在宠物友好区域设置提示牌、粪便袋取用点和休息区，并倡导养宠人主动牵绳、及时清理，让“友好”建立在相互尊重之上。',
    ],
    category: 'society',
    cover:
      'https://readdy.ai/api/search-image?query=bright%20documentary%20photo%20of%20people%20walking%20dogs%20on%20leashes%20in%20a%20green%20urban%20park%20path%2C%20daylight%2C%20blurred%20city%20background%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1020&orientation=landscape',
    author: '本网记者 周宁',
    source: '911爆料网',
    publishedAt: '2026-10-09T14:10:00+08:00',
    views: 15820,
    tags: ['养宠', '社区', '公共空间'],
  },
  {
    id: 'n1021',
    title: '突发：某市场周边商铺招牌坠落，现场无人员受伤',
    summary:
      '今日下午，某市场周边一处商铺招牌因固定件老化发生坠落，所幸未造成人员受伤，相关排查已展开。',
    content: [
      '据周边商户描述，招牌坠落时并非人流高峰，只有少量行人经过，事发后现场迅速被围挡隔离，避免二次风险。',
      '属地城管部门到场后，对周边同类招牌进行了安全排查，并提醒商户定期检查招牌的固定件与线路，及时加固存在隐患的设施。',
      '相关负责人表示，将结合季节性大风天气，开展户外广告与招牌的安全专项整治，保障过往行人和车辆的安全。',
    ],
    category: 'breaking',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20a%20commercial%20street%20with%20shop%20signboards%20and%20temporary%20safety%20barriers%20on%20the%20ground%2C%20daylight%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1021&orientation=landscape',
    author: '本网记者 林一',
    source: '911爆料网',
    publishedAt: '2026-10-09T16:40:00+08:00',
    views: 24110,
    tags: ['突发', '安全', '城市管理'],
  },
  {
    id: 'n1022',
    title: '突发：山区道路塌方致通行受阻，抢通工作持续进行',
    summary:
      '受持续降雨影响，某山区道路发生塌方，导致部分车辆滞留，抢修力量已进场作业，暂无人员伤亡报告。',
    content: [
      '据交通部门通报，塌方发生在一处傍山路段，落石与泥石堆积占据了部分路面，路政人员已设置警示标志并引导车辆绕行。',
      '现场抢险队伍表示，因土壤含水量较高，作业需兼顾安全，抢通将按“先通后畅”原则推进，优先保障应急车辆通行。',
      '相关部门提醒，近期山区降雨频繁，出行前应关注路况与预警信息，避免在降雨时段进入地质灾害易发路段。',
    ],
    category: 'breaking',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20a%20mountain%20road%20with%20fallen%20rocks%20and%20mud%20after%20heavy%20rain%2C%20warning%20signs%20and%20green%20hillside%2C%20overcast%20light%2C%20neutral%20cool%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1022&orientation=landscape',
    author: '本网记者 吴桐',
    source: '911爆料网',
    publishedAt: '2026-10-09T10:05:00+08:00',
    views: 27680,
    tags: ['突发', '交通', '天气'],
  },
  {
    id: 'n1023',
    title: '暑期托管班报名火热，家长更关心师资与安全',
    summary:
      '假期托管需求旺盛，不少社区推出公益性质的托管服务，家长在报名时最关注师资配备与日常安全管理。',
    content: [
      '“上班没人带孩子”是不少双职工家庭的现实难题。今年暑期，多个社区开设了托管班，提供看护、作业辅导和兴趣活动。',
      '记者走访发现，公益托管班价格相对亲民，但名额紧张。家长普遍关心带班老师是否具备资质、场所是否安全、午休与餐食如何安排。',
      '工作人员介绍，托管班已引入大学生志愿者和专业社工，并制定安全应急预案，同时通过家长群实时反馈孩子的日常情况。',
    ],
    category: 'livelihood',
    cover:
      'https://readdy.ai/api/search-image?query=bright%20photo%20of%20children%20doing%20homework%20and%20crafts%20at%20tables%20in%20a%20community%20activity%20room%20with%20colorful%20walls%2C%20soft%20daylight%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1023&orientation=landscape',
    author: '本网记者 周宁',
    source: '911爆料网',
    publishedAt: '2026-10-08T17:30:00+08:00',
    views: 19120,
    tags: ['教育', '托管', '民生'],
  },
  {
    id: 'n1024',
    title: '社区增设电动自行车充电位，缓解“停车难充电难”',
    summary:
      '针对电动车充电需求，多个社区新增集中充电位，并引入智能断电与消防设施，减少“飞线充电”隐患。',
    content: [
      '“以前只能从楼上拉线，既不方便也不安全。”随着社区新增集中充电点，居民不再为充电发愁，楼道里的“飞线”也明显减少。',
      '新的充电棚配备了智能断电、烟感报警和灭火装置，并设置了遮雨顶棚与照明，扫码即可充电，费用按次结算。',
      '物业表示，后续将根据使用频率动态增加点位，并加强巡查，引导居民规范停放，共同维护安全整洁的居住环境。',
    ],
    category: 'livelihood',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20a%20covered%20electric%20bicycle%20charging%20area%20in%20a%20residential%20community%20with%20parked%20scooters%20and%20clear%20signage%2C%20daylight%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1024&orientation=landscape',
    author: '本网记者 陈默',
    source: '911爆料网',
    publishedAt: '2026-10-08T11:15:00+08:00',
    views: 16430,
    tags: ['社区', '安全', '电动车'],
  },
  {
    id: 'n1025',
    title: '滨江步道贯通开放，市民多了休闲好去处',
    summary:
      '随着最后一段步道完成建设，滨江步道实现全线贯通，跑步、骑行与散步的市民络绎不绝。',
    content: [
      '新贯通的滨江步道串联起沿线多个公园与观景平台，沿途设置了休息驿站、饮水点和自行车道，成为市民休闲锻炼的热门去处。',
      '不少市民表示，以前跑步要绕行马路，现在可以沿着江边一路向前，视野开阔、体验更好。傍晚时分，步道上更是热闹。',
      '管理方介绍，后续将完善夜间照明与便民设施，并加强沿线保洁与秩序维护，让这条“城市绿廊”长久地服务市民。',
    ],
    category: 'local',
    cover:
      'https://readdy.ai/api/search-image?query=wide%20photo%20of%20a%20riverside%20walking%20and%20cycling%20promenade%20with%20people%20jogging%20at%20sunset%2C%20city%20skyline%20reflected%20on%20the%20water%2C%20warm%20golden%20light%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1025&orientation=landscape',
    author: '本网记者 吴桐',
    source: '911爆料网',
    publishedAt: '2026-10-07T18:45:00+08:00',
    views: 14980,
    tags: ['城市', '休闲', '滨江'],
  },
  {
    id: 'n1026',
    title: '老街夜市回归，烟火气里藏着治理新课题',
    summary:
      '停摆多年的老街夜市重新开张，人气回归的同时，噪音、油烟与交通秩序也给属地治理提出新考验。',
    content: [
      '入夜后，老街两侧的摊位次第亮起灯光，小吃、手作与文创汇集，久违的烟火气让不少居民感慨“熟悉的味道回来了”。',
      '但人气也带来新问题：部分摊位油烟直排、经营到深夜影响周边住户休息，周末时段周边道路也容易出现拥堵。',
      '属地管理部门表示，正在推行摊位分区、油烟净化与限时经营等措施，并引导摊主自治，在保留烟火气的同时兼顾居民生活。',
    ],
    category: 'local',
    cover:
      'https://readdy.ai/api/search-image?query=night%20photo%20of%20a%20lively%20old%20street%20night%20market%20with%20food%20stalls%20and%20warm%20hanging%20lights%2C%20crowds%20of%20visitors%2C%20soft%20glow%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1026&orientation=landscape',
    author: '本网记者 周宁',
    source: '911爆料网',
    publishedAt: '2026-10-07T21:20:00+08:00',
    views: 22310,
    tags: ['夜市', '城市治理', '烟火气'],
  },
  {
    id: 'n1027',
    title: '调查：低价旅游团“购物陷阱”为何屡禁不止',
    summary:
      '以超低价吸引报名的旅游团，往往通过强制或变相购物回收成本，记者就此走访多位参团游客。',
    content: [
      '“几百块就能玩好几天”的低价团，对价格敏感的游客颇有吸引力。但多位游客反映，行程中购物点一个接一个，停留时间远超景点。',
      '记者调查发现，部分旅行社将团费压低后，通过购物返点弥补成本，甚至以“不购物就甩团”等方式施压，游客往往因人生地不熟而被迫消费。',
      '文旅部门提醒，游客应选择正规旅行社并签订合同，警惕明显低于成本的报价。遇到强迫购物，可保留证据并及时投诉。',
    ],
    quote: '“便宜到不合常理的团费，成本往往会以别的方式被收回。”',
    category: 'investigation',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20tour%20group%20with%20a%20guide%20flag%20walking%20through%20a%20souvenir%20shop%2C%20shelves%20of%20goods%2C%20cool%20neutral%20tones%2C%20investigative%20news%20style%2C%20high%20detail%2C%20documentary%20feel&width=800&height=500&seq=news-1027&orientation=landscape',
    author: '本网调查组',
    source: '911爆料网',
    publishedAt: '2026-10-06T15:00:00+08:00',
    views: 35870,
    tags: ['消费调查', '旅游', '维权'],
    hot: true,
  },
  {
    id: 'n1028',
    title: '调查：部分保健品讲座专盯老年人，专家提醒理性消费',
    summary:
      '以健康讲座、免费体验为名的推销活动瞄准老年群体，记者调查其常见话术与销售套路。',
    content: [
      '记者以旁观者身份参加了一场面向老年人的“健康讲座”。活动以免费量血压、送小礼品开场，随后由“专家”推介高价保健品。',
      '调查了解到，这类活动常利用老年人对健康的关注和对陪伴的需求，通过“一对一关怀”逐步建立信任，再诱导大额购买，产品功效往往被夸大。',
      '市场监管部门提醒，保健品不能替代药品，老年朋友购买前应与家人商量，认准正规渠道与批准文号，谨防被“情感营销”裹挟。',
    ],
    category: 'investigation',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20photo%20of%20older%20adults%20attending%20a%20health%20seminar%20in%20a%20plain%20meeting%20room%20with%20product%20boxes%20on%20a%20table%2C%20neutral%20indoor%20lighting%2C%20cool%20tones%2C%20investigative%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1028&orientation=landscape',
    author: '本网调查组',
    source: '911爆料网',
    publishedAt: '2026-10-06T10:40:00+08:00',
    views: 29420,
    tags: ['消费调查', '养老', '防骗'],
  },
  {
    id: 'n1029',
    title: '视频：公交司机暖心等待行动不便乘客，乘客点赞',
    summary:
      '一段公交车内的监控视频感动了不少网友：司机在站点耐心等待行动不便的乘客上车，并主动上前搀扶。',
    content: [
      '视频中，公交车缓缓停靠在站台，司机从后视镜看到一位行动不便的乘客正朝车门走来，随即拉好手刹起身相迎。',
      '待乘客坐稳后，司机才重新启动车辆。整个过程虽然只有短短几十秒，却让车厢里的乘客纷纷投来赞许的目光。',
      '公交公司表示，这样的服务是日常运营中的一个小细节，也希望通过这些平凡的善意，让城市出行更有温度。',
    ],
    category: 'video',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20frame%20of%20a%20city%20bus%20interior%20with%20a%20driver%20helping%20an%20elderly%20passenger%20to%20a%20seat%2C%20warm%20indoor%20lighting%2C%20neutral%20tones%2C%20candid%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1029&orientation=landscape',
    author: '网友投稿',
    source: '911爆料网',
    publishedAt: '2026-10-05T19:25:00+08:00',
    views: 20980,
    tags: ['视频', '正能量', '公交'],
  },
  {
    id: 'n1030',
    title: '视频曝光：小区消防通道被占用，居民呼吁保持畅通',
    summary:
      '有居民向本网投稿视频，反映小区消防通道长期被车辆和杂物占用，担心紧急情况下影响救援。',
    content: [
      '视频画面中，一条标注“消防通道 禁止占用”的道路上停放着多辆私家车，角落还堆放着闲置的家具和纸箱。',
      '多位居民表示，这类情况在晚间尤其明显，一旦发生火情，消防车可能无法顺利通行，存在不小的安全隐患。',
      '物业回应称，将联合社区加强巡查与劝导，对占用通道的车辆进行清理和贴条提醒，并重新施划标线，确保生命通道畅通。',
    ],
    category: 'video',
    cover:
      'https://readdy.ai/api/search-image?query=documentary%20photo%20of%20a%20residential%20community%20road%20marked%20as%20fire%20lane%20with%20parked%20cars%20and%20miscellaneous%20items%2C%20daylight%2C%20neutral%20tones%2C%20editorial%20news%20style%2C%20high%20detail&width=800&height=500&seq=news-1030&orientation=landscape',
    author: '网友投稿',
    source: '911爆料网',
    publishedAt: '2026-10-05T14:50:00+08:00',
    views: 18640,
    tags: ['视频', '安全', '监督'],
  },
];

export const getCategoryById = (id: string): NewsCategory | undefined =>
  categories.find((item) => item.id === id);

export const getCategoryName = (id: string): string =>
  categories.find((item) => item.id === id)?.name ?? '未分类';